<script lang="ts" setup>
import { openUrlInNewTab } from '@/utils/dom.utils';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const emit = defineEmits<{
  'create-offer': [];
}>();

withDefaults(
  defineProps<{
    showOfferLink?: boolean;
    showVatNotice?: boolean;
    showComparePlansLink?: boolean;
  }>(),
  {
    showOfferLink: false,
    showVatNotice: true,
    showComparePlansLink: true,
  },
);

const handleRedirectPlans = (): void => {
  openUrlInNewTab(t('website.pricingUrl'));
};
</script>

<template>
  <div class="flex flex-wrap justify-start gap-sm text-secondary max-md:text-footer">
    <button
      v-if="showOfferLink"
      class="cursor-pointer appearance-none border-0 bg-transparent p-0 text-left font-[inherit] text-secondary underline"
      type="button"
      @click="emit('create-offer')"
    >
      {{ t('billing.offers.createOffer') }}
    </button>
    <span v-if="showOfferLink && (showComparePlansLink || showVatNotice)">•</span>
    <a v-if="showComparePlansLink" class="underline cursor-pointer" @click="handleRedirectPlans()">
      {{ t('billing.buttons.comparePlans') }}
    </a>
    <template v-if="showVatNotice">
      <span v-if="showComparePlansLink">•</span>
      <span>{{ t('billing.pricesExclVat') }}</span>
    </template>
  </div>
</template>
